export function ThumbIcon() {
  return <img src="/pictures/thumbs-up-icon.png" alt="success" />;
}
